import { FC } from 'react';

import { Toaster as ShadcnToaster } from '../shadcn/Toaster';
import { useAdaptive } from '../../hooks';
import { DEFAULT_TOAST_DURATION_MS } from './toastDedupe';

type TToasterProps = {
  className?: string;
};

export const Toaster: FC<TToasterProps> = ({ className }) => {
  const { isMobile } = useAdaptive();

  return (
    <ShadcnToaster
      className={className}
      position={isMobile ? 'top-center' : 'top-right'}
      duration={DEFAULT_TOAST_DURATION_MS}
      expand={false}
      richColors
      closeButton
    />
  );
};
